/* @flow */
import * as React from 'react';

import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle';
import Container from 'components/Container';
import Row from 'components/Row';

import './styles/AdminUpgradeInformationalPage.scss';

type Props = {
  // If you'd like to override the header on AdminUpgradePageHeader
  headerTitle?: string,
  // Primary content on the page
  title: string,
  subtext: any,
  action?: any,
  children?: React.Node,
};

export default class AdminUpgradeInformationalPage extends React.Component<Props> {
  render() {
    const { headerTitle, title, subtext, action, children } = this.props;
    return (
      <div className="AdminUpgradePageView">
        <AdminUpgradePageHeader
          title={headerTitle || 'The Remind plan for schools and districts'}
          hideHelp
        />
        <Container size="large" className="AdminUpgradePageView-content">
          <div className="AdminUpgradeInformationalPage-content">
            <AdminUpgradeTitle
              text={<Row size="xsmall">{title}</Row>}
              subtext={<Row size="medium">{subtext}</Row>}
            />
            <Row size="small">{action}</Row>
            {children}
          </div>
        </Container>
      </div>
    );
  }
}
